export function Contact() {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Contact</h1>
      <div className="bg-white shadow rounded-lg p-6">
        <p className="text-gray-700">
          Service maintained by Dennis Cao (
          <a
            href="mailto:Dennis.Cao@skims.com"
            className="text-blue-600 hover:text-blue-800 underline"
          >
            Dennis.Cao@skims.com
          </a>
          ), contact him for questions.
        </p>
      </div>
    </div>
  );
}
